module.exports = __webpack_public_path__ + "static/media/s2.e5bdac06.png";